/*
=============================================
Author      : <ยุทธภูมิ ตวันนา>
Create date : <๒๘/๑๐/๒๕๖๒>
Modify date : <๑๘/๐๒/๒๕๖๖>
Description : <>
=============================================
*/

'use strict';

import { NgModule, Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { Router, Event, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AppService } from './app.service';
import { AuthService } from './auth.service';
import { ModalService } from './modal/modal.service';

@NgModule({
    providers: [
        AppService
    ]
})

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    host: {
        '(window: resize)': 'onResize($event)'
    }
})

export class AppComponent implements OnInit {
    @ViewChild('headerView', { static: false }) headerView: ElementRef;
    @ViewChild('footerView', { static: false }) footerView: ElementRef;

    constructor(
        private router: Router,
        private modal: NgbModal,
        private appService: AppService,
        private authService: AuthService,
        private modalService: ModalService
    ) {
        this.router.events.subscribe((event: Event) => {
            switch (true) {
                case event instanceof NavigationStart:
                    if (this.modal.hasOpenModals())
                        this.modal.dismissAll("");

                    appService.isLoading.show = true;
                    appService.isLoading.page = true;
                    this.toggle.menu = false;
                    this.toggle.searchProject = false;
                    this.doHeaderGetToggle();
                    break;
                case event instanceof NavigationEnd:
                case event instanceof NavigationCancel:
                case event instanceof NavigationError:
                    this.appService.setSysEvent().then(() => {;
                        setTimeout(() => {
                            appService.isLoading.show = false;
                            appService.isLoading.page = false;
                        }, 1000);
                    });
                    break;
                default: {
                    break;
                }
            }
        });
    }

    userBackgrondColor: string;
    sectionStyle = {};
    today: Date = new Date();
    toggle = {
        menu: false,
        searchProject: false
    };

    ngOnInit(): void {
        this.appService.setURLServer();
        this.appService.setDefaultLang(this.appService.lang);
        this.appService.setFormLabelActive();
        this.userBackgrondColor = this.appService.getRandomColor();
    }

    ngAfterViewChecked(): void {
        this.sectionStyle = this.getSectionStyle();
    }

    onResize(): void {
        this.sectionStyle = this.getSectionStyle();
        this.modalService.setModalSize();
    }

    getSectionStyle(): {} {
        this.appService.headerViewHeight = this.headerView.nativeElement.offsetHeight;

        return {
            'padding-top': (this.appService.headerViewHeight + 'px'),
            'padding-bottom': (this.footerView.nativeElement.offsetHeight + 'px')
        }
    }

    doGotoPrivacyPolicy(): void {
        location.href = ('https//privacy.mahidol.ac.th/' + this.appService.lang === 'en' ? 'en/home-en' : '');
    }

    doHeaderGetToggle(toggle?: string): void {
        let bodyClassList: DOMTokenList = document.getElementsByTagName('body')[0].classList;
        let toggleName: Array<string> = ['menu', 'searchproject'];

        toggleName.forEach(t => {
            bodyClassList.remove('header-toggle-' + t + '-open');
        });

        if (toggle === 'menu') {
            this.toggle.menu = !this.toggle.menu;
            this.toggle.searchProject = false;

            if (this.toggle.menu === true)
                bodyClassList.add('header-toggle-' + toggle + '-open');
        }

        if (toggle === 'searchproject') {
            this.toggle.menu = false;
            this.toggle.searchProject = !this.toggle.searchProject;

            if (this.toggle.searchProject === true)
                bodyClassList.add('header-toggle-' + toggle + '-open');
        }

        setTimeout(() => {
            this.sectionStyle = this.getSectionStyle();
        }, 0);
    }
}
